import { Box, Grid, Skeleton } from '@mui/material';

import TableSkeleton from '@root/components/table/skeleton';
import BasicContentBox from '@root/components/v2/content/BasicContentBox';
// import CloudProviderBarSkeleton from '@root/components/v2/content/CloudProviderBar/skeleton';
import PageContent from '@root/components/v2/layout/PageContent';
import PageHeaderSkeleton from '@root/components/v2/layout/PageHeader/Skeleton';

function EventOverviewSkleton() {
  return (
    <PageContent>
      <PageHeaderSkeleton />
      {/* <CloudProviderBarSkeleton /> */}

      <Grid container spacing={'15px'} style={{ marginBottom: '15px' }}>
        {/* Row 1 */}
        <Grid item xs={6}>
          <BasicContentBox title="Events" style={{ height: '405px' }}>
            <Skeleton height={361} style={{ transform: 'none' }} />
          </BasicContentBox>
        </Grid>
        <Grid item xs={6}>
          <BasicContentBox
            title="Top 10 Critical Threat & Anomaly Events"
            style={{ height: '405px' }}
            innerStyles={{ overflow: 'hidden' }}>
            <div style={{ height: 'calc(100% + 10px)' }}>
              <TableSkeleton COLUMNS_COUNT={5} ROWS_COUNT={7} hideFooter noBorder />
            </div>
          </BasicContentBox>
        </Grid>

        {/* Row 2 */}
        <Grid item xs={6}>
          <BasicContentBox title="Events Over Time" style={{ height: '350px' }} innerStyles={{ overflow: 'hidden' }}>
            <Grid>
              <Skeleton height={240} style={{ transform: 'none' }} sx={{ margin: '15px' }} />
            </Grid>
            <Grid sx={{ display: 'flex', margin: '15px 0px', justifyContent: 'center' }}>
              <Skeleton height={20} width={100} style={{ transform: 'none' }} sx={{ marginRight: '15px' }} />
              <Skeleton height={20} width={100} style={{ transform: 'none' }} />
            </Grid>
          </BasicContentBox>
        </Grid>
        <Grid item xs={6}>
          <BasicContentBox
            title="Most Critical Vulnerabilities"
            style={{ height: '350px' }}
            innerStyles={{ overflow: 'hidden' }}>
            <div style={{ height: 'calc(100% + 10px)' }}>
              <TableSkeleton COLUMNS_COUNT={5} ROWS_COUNT={7} hideFooter noBorder />
            </div>
          </BasicContentBox>
        </Grid>

        {/* Row 3 */}
        <Grid item xs={6}>
          <BasicContentBox
            title="Anomalous CloudTrail API Activity"
            style={{ height: '350px' }}
            innerStyles={{ overflow: 'hidden' }}>
            <div style={{ height: 'calc(100% + 10px)' }}>
              <TableSkeleton COLUMNS_COUNT={5} ROWS_COUNT={7} hideFooter noBorder />
            </div>
          </BasicContentBox>
        </Grid>
        <Grid item xs={6}>
          <BasicContentBox
            title="MITRE Discovery Activity for Role"
            style={{ height: '350px' }}
            innerStyles={{ overflow: 'hidden' }}>
            <div style={{ height: 'calc(100% + 10px)' }}>
              <TableSkeleton COLUMNS_COUNT={5} ROWS_COUNT={7} hideFooter noBorder />
            </div>
          </BasicContentBox>
        </Grid>

        {/* Row 4 - 3 Threat Cards (Pie Charts) */}
        <Grid item xs={4}>
          <BasicContentBox title="Threats By Severity" style={{ height: '400px' }}>
            <Box display="flex" justifyContent="center" alignItems="center" height="100%">
              <Box display="flex" width="100%" justifyContent="space-between" padding="30px">
                <Box display="flex" flexDirection="column" height="120px">
                  {Array.from(new Array(5)).map((_, index) => (
                    <Skeleton key={index} width="130px" height="25px" />
                  ))}
                </Box>
                <Box height="120px">
                  <Skeleton variant="circular" width={120} height={120} />
                </Box>
                <Box height="120px">
                  {Array.from(new Array(5)).map((_, index) => (
                    <Skeleton key={index} width="130px" height="25px" />
                  ))}
                </Box>
              </Box>
            </Box>
          </BasicContentBox>
        </Grid>
        <Grid item xs={4}>
          <BasicContentBox title="Threats By Type" style={{ height: '400px' }}>
            <Box display="flex" justifyContent="center" alignItems="center" height="100%">
              <Box display="flex" width="100%" justifyContent="space-between" padding="30px">
                <Box display="flex" flexDirection="column" height="120px">
                  {Array.from(new Array(5)).map((_, index) => (
                    <Skeleton key={index} width="130px" height="25px" />
                  ))}
                </Box>
                <Box height="120px">
                  <Skeleton variant="circular" width={120} height={120} />
                </Box>
                <Box height="120px">
                  {Array.from(new Array(5)).map((_, index) => (
                    <Skeleton key={index} width="130px" height="25px" />
                  ))}
                </Box>
              </Box>
            </Box>
          </BasicContentBox>
        </Grid>
        <Grid item xs={4}>
          <BasicContentBox title="Threats By Source" style={{ height: '400px' }}>
            <Box display="flex" justifyContent="center" alignItems="center" height="100%">
              <Box display="flex" width="100%" justifyContent="space-between" padding="30px">
                <Box display="flex" flexDirection="column" height="120px">
                  {Array.from(new Array(5)).map((_, index) => (
                    <Skeleton key={index} width="130px" height="25px" />
                  ))}
                </Box>
                <Box height="120px">
                  <Skeleton variant="circular" width={120} height={120} />
                </Box>
                <Box height="120px">
                  {Array.from(new Array(5)).map((_, index) => (
                    <Skeleton key={index} width="130px" height="25px" />
                  ))}
                </Box>
              </Box>
            </Box>
          </BasicContentBox>
        </Grid>

        {/* Row 5 */}
        <Grid item xs={6}>
          <BasicContentBox
            title="Remediation Over Time"
            style={{ height: '375px' }}
            innerStyles={{ overflow: 'hidden' }}>
            <Grid>
              <Skeleton height={240} style={{ transform: 'none' }} sx={{ margin: '15px' }} />
            </Grid>
            <Grid sx={{ display: 'flex', margin: '15px 0px', justifyContent: 'center' }}>
              <Skeleton height={20} width={100} style={{ transform: 'none' }} sx={{ marginRight: '15px' }} />
              <Skeleton height={20} width={100} style={{ transform: 'none' }} />
            </Grid>
          </BasicContentBox>
        </Grid>
        <Grid item xs={6}>
          <BasicContentBox title="Drift Events" style={{ height: '375px' }} innerStyles={{ overflow: 'hidden' }}>
            <Grid>
              <Skeleton height={240} style={{ transform: 'none' }} sx={{ margin: '15px' }} />
            </Grid>
            <Grid sx={{ display: 'flex', margin: '15px 0px', justifyContent: 'center' }}>
              <Skeleton height={20} width={100} style={{ transform: 'none' }} sx={{ marginRight: '15px' }} />
              <Skeleton height={20} width={100} style={{ transform: 'none' }} />
              <Skeleton height={20} width={100} style={{ transform: 'none' }} />
            </Grid>
          </BasicContentBox>
        </Grid>

        {/* Row 6 */}
        <Grid item xs={4}>
          <BasicContentBox title="Delete Events Over Time" style={{ height: '500px' }}>
            <Box height="100%" width="100%" padding="15px" gap="15px" display="flex" flexDirection="column">
              {Array.from(new Array(10)).map((_, i) => (
                <Box key={i} height="30px" width="100%">
                  <Skeleton variant="rectangular" height="100%" width="100%" />
                </Box>
              ))}
            </Box>
          </BasicContentBox>
        </Grid>
        <Grid item xs={8}>
          <BasicContentBox title="Top 10 Drift Events" style={{ height: '500px' }} innerStyles={{ overflow: 'hidden' }}>
            <div style={{ height: 'calc(100% + 10px)' }}>
              <TableSkeleton COLUMNS_COUNT={5} ROWS_COUNT={8} hideFooter noBorder />
            </div>
          </BasicContentBox>
        </Grid>
      </Grid>

      {/* Second Grid Container - LinearProgress Cards */}
      <Grid container spacing={'15px'}>
        <Grid item xs={4}>
          <BasicContentBox
            title="Top 10 Failed Events"
            style={{ height: '284px' }}
            titleContainerStyles={{ borderBottom: '0px' }}>
            <Box height="100%">
              <Box display="flex" justifyContent="space-between" padding="10px">
                <Skeleton width="150px" height="25px" />
                <Skeleton width="150px" height="25px" />
              </Box>
              <Box display="flex" justifyContent="space-between" width="100%" height="80%" padding="10px">
                <Box display="flex" flexDirection="column" boxSizing="border-box" height="100%">
                  {Array.from(new Array(10)).map((_, index) => (
                    <Skeleton key={`failed-events-left-${index}`} width="150px" height="25px" />
                  ))}
                </Box>
                <Box display="flex" flexDirection="column" boxSizing="border-box" height="100%">
                  {Array.from(new Array(10)).map((_, index) => (
                    <Skeleton key={`failed-events-right-${index}`} width="150px" height="25px" />
                  ))}
                </Box>
              </Box>
            </Box>
          </BasicContentBox>
        </Grid>
        <Grid item xs={4}>
          <BasicContentBox
            title="Top 10 Failed IP"
            style={{ height: '284px' }}
            titleContainerStyles={{ borderBottom: '0px' }}>
            <Box height="100%">
              <Box display="flex" justifyContent="space-between" padding="10px">
                <Skeleton width="150px" height="25px" />
                <Skeleton width="150px" height="25px" />
              </Box>
              <Box display="flex" justifyContent="space-between" width="100%" height="80%" padding="10px">
                <Box display="flex" flexDirection="column" boxSizing="border-box" height="100%">
                  {Array.from(new Array(10)).map((_, index) => (
                    <Skeleton key={`failed-ip-left-${index}`} width="150px" height="25px" />
                  ))}
                </Box>
                <Box display="flex" flexDirection="column" boxSizing="border-box" height="100%">
                  {Array.from(new Array(10)).map((_, index) => (
                    <Skeleton key={`failed-ip-right-${index}`} width="150px" height="25px" />
                  ))}
                </Box>
              </Box>
            </Box>
          </BasicContentBox>
        </Grid>
        <Grid item xs={4}>
          <BasicContentBox
            title="Top 10 Failed Users"
            style={{ height: '284px' }}
            titleContainerStyles={{ borderBottom: '0px' }}>
            <Box height="100%">
              <Box display="flex" justifyContent="space-between" padding="10px">
                <Skeleton width="150px" height="25px" />
                <Skeleton width="150px" height="25px" />
              </Box>
              <Box display="flex" justifyContent="space-between" width="100%" height="80%" padding="10px">
                <Box display="flex" flexDirection="column" boxSizing="border-box" height="100%">
                  {Array.from(new Array(10)).map((_, index) => (
                    <Skeleton key={`failed-users-left-${index}`} width="150px" height="25px" />
                  ))}
                </Box>
                <Box display="flex" flexDirection="column" boxSizing="border-box" height="100%">
                  {Array.from(new Array(10)).map((_, index) => (
                    <Skeleton key={`failed-users-right-${index}`} width="150px" height="25px" />
                  ))}
                </Box>
              </Box>
            </Box>
          </BasicContentBox>
        </Grid>
        <Grid item xs={4}>
          <BasicContentBox
            title="Most Active Actors"
            style={{ height: '284px' }}
            titleContainerStyles={{ borderBottom: '0px' }}>
            <Box height="100%">
              <Box display="flex" justifyContent="space-between" padding="10px">
                <Skeleton width="150px" height="25px" />
                <Skeleton width="150px" height="25px" />
              </Box>
              <Box display="flex" justifyContent="space-between" width="100%" height="80%" padding="10px">
                <Box display="flex" flexDirection="column" boxSizing="border-box" height="100%">
                  {Array.from(new Array(10)).map((_, index) => (
                    <Skeleton key={`active-actors-left-${index}`} width="150px" height="25px" />
                  ))}
                </Box>
                <Box display="flex" flexDirection="column" boxSizing="border-box" height="100%">
                  {Array.from(new Array(10)).map((_, index) => (
                    <Skeleton key={`active-actors-right-${index}`} width="150px" height="25px" />
                  ))}
                </Box>
              </Box>
            </Box>
          </BasicContentBox>
        </Grid>
        <Grid item xs={4}>
          <BasicContentBox
            title="Top 10 Events By Environment"
            style={{ height: '284px' }}
            titleContainerStyles={{ borderBottom: '0px' }}>
            <Box height="100%">
              <Box display="flex" justifyContent="space-between" padding="10px">
                <Skeleton width="150px" height="25px" />
                <Skeleton width="150px" height="25px" />
              </Box>
              <Box display="flex" justifyContent="space-between" width="100%" height="80%" padding="10px">
                <Box display="flex" flexDirection="column" boxSizing="border-box" height="100%">
                  {Array.from(new Array(10)).map((_, index) => (
                    <Skeleton key={`env-left-${index}`} width="150px" height="25px" />
                  ))}
                </Box>
                <Box display="flex" flexDirection="column" boxSizing="border-box" height="100%">
                  {Array.from(new Array(10)).map((_, index) => (
                    <Skeleton key={`env-right-${index}`} width="150px" height="25px" />
                  ))}
                </Box>
              </Box>
            </Box>
          </BasicContentBox>
        </Grid>
        <Grid item xs={4}>
          <BasicContentBox
            title="Top Events By Country"
            style={{ height: '284px' }}
            titleContainerStyles={{ borderBottom: '0px' }}>
            <Box height="100%">
              <Box display="flex" justifyContent="space-between" padding="10px">
                <Skeleton width="150px" height="25px" />
                <Skeleton width="150px" height="25px" />
              </Box>
              <Box display="flex" justifyContent="space-between" width="100%" height="80%" padding="10px">
                <Box display="flex" flexDirection="column" boxSizing="border-box" height="100%">
                  {Array.from(new Array(10)).map((_, index) => (
                    <Skeleton key={`country-left-${index}`} width="150px" height="25px" />
                  ))}
                </Box>
                <Box display="flex" flexDirection="column" boxSizing="border-box" height="100%">
                  {Array.from(new Array(10)).map((_, index) => (
                    <Skeleton key={`country-right-${index}`} width="150px" height="25px" />
                  ))}
                </Box>
              </Box>
            </Box>
          </BasicContentBox>
        </Grid>
      </Grid>
    </PageContent>
  );
}

export default EventOverviewSkleton;
